export const debugStackLinking = {
    screens: {}
};
export const debugTabsLinking = {
    screens: {
        Debug_Settings: {
            path: 'debug/*',
        }
    }
};
